module.exports = __webpack_public_path__ + "img/08_noff_close_L2.2abc4f54.svg";